/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Batch_PushInputs */



/**
* | output |
* | --- |
* | "VEKN push" |
*
* @param {Admin_Status_Batch_PushInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_batch_push = /** @type {((inputs?: Admin_Status_Batch_PushInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Batch_PushInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Envío VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Envio VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio VEKN")
	return /** @type {LocalizedString} */ ("VEKN push")
});